import { useField } from "remix-validated-form";
import { AppConfig } from "~/AppConfig";
import { Combobox } from "~/components/shared";
import type { ComboboxProps } from "~/components/shared/Combobox";

type ComboboxInput_v2_Props = ComboboxProps

function ComboboxInput_v2(props: ComboboxInput_v2_Props) {
  const { name, helperText, ...restProps } = props

  const { error, getInputProps } = useField(name, {
    validationBehavior: AppConfig.InputValidationBehavior
  })

  return <Combobox
    {...getInputProps({
      ...restProps,
      helperText: error || helperText || '',
      error: !!error
    })}

  />
}

export default ComboboxInput_v2
